import React from "react";
import "./home.css";
import Ticker from "./Ticker";
import { usePointerParallax } from "../../lib/usePointerParallax";
import Icon from "../ui/Icon";
import { profile } from "../../data/site";
import { projects, statusTone } from "../work/Data";

const spotlight = projects.filter((p) => p.featured).slice(0, 3);
const TICKER = ["Build", "Verify", "Measure", "Explain", "Ship"];

/** Headline set line by line so each line can mask-reveal on load. */
const LINES = [
  "Software engineer",
  <>
    building <em>ML systems,</em>
  </>,
  "developer tools",
  "and GPU software.",
];

const Stamp = () => (
  <svg
    className="stamp"
    viewBox="0 0 120 120"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <path
        id="stamp-ring"
        d="M60 60 m-45 0 a45 45 0 1 1 90 0 a45 45 0 1 1 -90 0"
      />
    </defs>
    <circle cx="60" cy="60" r="58" className="stamp__disc" />
    <text className="stamp__text">
      <textPath href="#stamp-ring" textLength="278" lengthAdjust="spacing">
        SOFTWARE ENGINEER · BENGALURU · M.TECH ·
      </textPath>
    </text>
    <circle cx="60" cy="60" r="9" className="stamp__dot" />
  </svg>
);

const Home = ({ onOpenProject }) => {
  const heroRef = usePointerParallax();
  return (
    <section
      className="hero"
      id="top"
      aria-labelledby="hero-title"
      ref={heroRef}
    >
      <div className="hero__grid container">
        <div className="hero__copy">
          <p className="eyebrow rise" style={{ "--i": 0 }}>
            {profile.name} · {profile.location}
          </p>

          <h1 id="hero-title" className="hero__title">
            {LINES.map((line, i) => (
              <React.Fragment key={i}>
                <span className="hero__line">
                  <span style={{ "--i": i }}>{line}</span>
                </span>{" "}
              </React.Fragment>
            ))}
          </h1>

          <p className="hero__lead rise" style={{ "--i": 5 }}>
            M.Tech Computer Science student at Manipal Institute of Technology.
            I like systems that can check themselves: drift detectors,
            evaluation gates, explainable scores, and parallel code that is
            correct before it is fast.
          </p>

          <div className="hero__cta rise" style={{ "--i": 6 }}>
            <a className="btn btn--primary" href="#work">
              View projects <Icon name="arrow" />
            </a>
            <a
              className="btn"
              href={profile.github}
              target="_blank"
              rel="noreferrer"
            >
              <Icon name="github" /> GitHub
              <span className="sr-only"> (opens in a new tab)</span>
            </a>
          </div>
        </div>

        <div className="hero__visual rise" style={{ "--i": 3 }}>
          <figure className="portrait">
            <img
              src="/assets/samartha-portrait.jpg"
            srcSet="/assets/samartha-720.jpg 720w, /assets/samartha-portrait.jpg 800w"
            sizes="(max-width: 900px) 340px, 28vw"
              width="800"
              height="1000"
              alt="Portrait of Samartha H V in sunglasses against a blue sky"
              fetchpriority="high"
              decoding="async"
            />
            <Stamp />
          </figure>

          <ul className="hero__chips" aria-label="Selected work">
            {spotlight.map((p, i) => (
              <li key={p.slug} className="hero__chip-item" style={{ "--n": i }}>
                <button
                  type="button"
                  className="hero__chip"
                  onClick={() => onOpenProject(p.slug)}
                >
                  <span className="hero__chip-fig" aria-hidden="true">
                    FIG.{String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="hero__chip-text">
                    <strong>{p.title}</strong>
                    <small
                      className={`hero__chip-status hero__chip-status--${statusTone[p.status]}`}
                    >
                      {p.status}
                    </small>
                  </span>
                  <Icon name="arrow" />
                  <span className="sr-only"> open case file</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Ticker words={TICKER} />
    </section>
  );
};

export default Home;
